<template>
  <el-container  style="display: block;">

    <el-row   style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">
        





      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            
            <el-table-column

              width="400"
              label="内容"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.content}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="视频地址"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.url}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="200"
              label="操作"
               >
               <template slot-scope="scope">
                 <div @click="bofang(scope.row.url)" style="color: blue;">播放视频</div>
               </template>
            </el-table-column>
             
            </el-table>
          </template>

        </el-row>






    </el-row>
    <el-dialog
      title="播放"
      :visible.sync="disbo"
      width="30%"
      center>
      <video autoplay loop playsinline  width="100%" height="100%" ref="videoPlayer"  controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true">
        <source :src="video" type="video/mp4" />
      </video>
    </el-dialog> 
    
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         video:'', 
         list:[],
         m_id:this.$route.query.id, 
		 disbo:false

      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    
	bofang(url){
		this.video = url
		// console.log(URL)
		this.disbo = true
		this.$nextTick(() => {
		  if (this.$refs.videoPlayer) {
			this.$refs.videoPlayer.load();
		    this.$refs.videoPlayer.play();
		  }
		});
	},
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          m_id:this.m_id,


      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/mianShiUsersList'
      })
      .then(res=>{

        this.list = res.data.data;




      })
      .catch(err=>{

      });
    },
    
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/mianshilists.vue